<div class="title">
  <h2>Edit Quickflow</h2>
  <nav class="navigation-links">
    @for (menuItem of displayedMenuItems; track menuItem; let i = $index) {
    <div class="navigation-link-outer">
      <a class="navigation-link" [class.active]="menuItem.text === step" [class.disabled]="menuItem.text !== step">
        <p class="navigation-link__text">{{ menuItem.text }}</p>
      </a>
    </div>
    }
  </nav>
  <pdq-input class="internal-name" [formControl]="internalName" placeholder="Internal name..." type="text"> </pdq-input>
  <div class="close-btn" title="close" (click)="onClose()"></div>
</div>
<pdq-divider></pdq-divider>
<div class="body">
  <pdq-button variant="ghost" icon="back" label="BACK" (onClick)="onBackHandler()"> </pdq-button>

  <ng-template #target></ng-template>
</div>
<div class="body__actions">
  <pdq-button
    variant="primary"
    [disabled]="!(isActionInsertedProperly(selectedAction) && isConditionsInsertedProperly(selectedConditions)&& isConditionsAndActionsWorkTogether(selectedConditions,selectedAction))"
    (onClick)="editWorkflow()"
    label="Save Quickflow">
  </pdq-button>
</div>
